import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import { SlideInModal } from 'syf-component-library/ui/patterns/SlideInModal'
import Button from 'syf-component-library/ui/atoms/Button'
import { colors } from 'const/colors'
import query from 'mediaQueries'
import Body from 'syf-component-library/ui/typography/Body'
import { SwitchAccountProps } from 'typings/switchAccount'
import Icon from 'ui/atoms/Icon'

const getParentAccountCSS = (
  isParent: boolean,
  relationship: boolean
): FlattenSimpleInterpolation => {
  return (
    relationship &&
    (isParent
      ? css`
          border: solid 1px ${colors.greyFifty};
          background-color: ${colors.greyThirty};
        `
      : css`
          border: solid 1px ${colors.greyFifty};
          background-color: ${colors.greyFive};
        `)
  )
}

export const SwitchAccountContainer = styled(SlideInModal)`
  width: 100%;
  @media ${query.greaterThanSmall} {
    display: flex;
    flex-direction: column;
    width: 408px;
  }
`

export const SwitchAccountHeader = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitchAccountBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitchAccountFooter = styled.div`
  margin: auto 0 0;
  padding: 16px;
  background-color: ${colors.greyTwenty};
  @media ${query.greaterThanTiny} {
    padding: 16px 32px;
  }
`

export const GoToAccountButton = styled(Button)`
  margin: 0;
  font-size: 14px;
  width: 100%;
  font-weight: 600;
`

export const SwitchSearchContainer = styled.div`
  display: flex;
  background-color: ${colors.greyTwenty};
  padding: 24px 32px;
  justify-content: center;
  & > div {
    width: 100%;
  }

  & > div > div {
    background-color: ${colors.white};
  }
`

export const SearchIcon = styled(Icon)`
  font-size: 19px;
  color: ${colors.darkGrey};
`

const SecondaryAccountCSS = css`
  border: solid 2px ${colors.greyEighty};
  background-color: ${colors.white};
`

export const PrimaryAccount = styled(Button)`
  height: auto;
  min-height: 26px;
  border-radius: 5px;
  border: solid 2px ${colors.greyEighty};
  background-color: ${colors.white};
  margin: 0 0 14px 31px;
  cursor: pointer;
  &:nth-child(1) {
    margin: 0 0 14px 0;
    ${({ isParent, relationship }: SwitchAccountProps) =>
      getParentAccountCSS(isParent, relationship)}
    ${({ isSecondary }) => isSecondary && SecondaryAccountCSS}
  }
  @media ${query.greaterThanSmall} {
    &:nth-child(1) {
      width: 100%;
      margin: 0 0 17px 0;
    }
  }
`

export const SecondaryAccount = styled(Button)`
  border-radius: 5px;
  border: solid 1px ${colors.greyFifty};
  background-color: ${colors.greyFive};
  margin: 0 0 14px 31px;
  height: auto;
  min-height: 26px;
  cursor: pointer;
  &:nth-child(1) {
    margin: 24px 12px 17px 32px;
  }
  @media ${query.greaterThanSmall} {
    &:nth-child(1) {
      margin: 44px 12px 17px 32px;
    }
  }
`

export const ListItemText = styled(Body)`
  font-size: 16px;
  padding: 0;
  margin: 0;
  padding-left: 10px;
  display: block;
  color: ${({ isPrimary, isSecondary }: SwitchAccountProps): string =>
    isPrimary && isSecondary ? colors.greyFifty : colors.greyEighty};
`
